<template>

    <div class="renderer universes">
        <span v-for="(universe,key) in universes" v-if="hasUniverse(key)" :class="{active:hasRoleForUniverse(key)}" :title="getTooltipForUniverse(universe)">
            <component v-bind:is="universe.icon" :class="universe.class"></component>
        </span>
    </div>

</template>

<script>
    //import Component from 'path/to/component'

    import {mapGetters} from 'vuex'
    import _find from 'lodash/find'
    import Utils from '@s/utils.js'

    export default {
        computed: {
            ...mapGetters({
                clientInfos: 'Papers/clientInfos'
            }),
            universes(){
                return Utils.themedUniverses();
            }
        },
        methods: {
            hasUniverse(slug){
                let result = _find(this.clientInfos.universes,o => {return o === slug})
                return !!result;
            },
            hasRoleForUniverse(slug) {
                let result = _find(this.roles,o => {return o.name.indexOf(slug+'-') != -1})
                return !!result;
            },
            getRoleForUniverse(slug) {
                let result = _find(this.roles,o => {return o.name.indexOf(slug+'-') != -1})
                return result;
            },
            getTooltipForUniverse(universe){
                let universeName = universe.name;
                let roleName = 'Pas d\'accès';

                if(this.hasRoleForUniverse(universe.class)){
                    roleName = this.getRoleForUniverse(universe.class).display_name
                }

                return 'Univers: ' + universeName + '\nRôle: ' + roleName;
            }

        },
        name: 'RendererUniverses',
        props: {
            roles:{
                type: Array,
                default: []
            }
        },
    }
</script>

<style lang="scss">
    .renderer.universes {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;

        $size: 30px;

        span{
            height: $size;
            width: $size;
            flex: 0 0 $size;
            margin: 2px 3px;



            .fleet,.beepiz{
                height: $size*0.6;
            }

            .park,.mission,.bom,.vision,.api,.admin{
                width: $size*0.6;
            }

            &:not(.active){
                opacity: 0.5;
            }
        }

    }
</style>


// WEBPACK FOOTER //
// src/components/users/RendererUniverses.vue